
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IClassCode } from "@tylertech/tyler-api-types";

/**
 * ItemClassService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ItemClassService {
    private readonly $apiService = inject(ApiService);
    
    AddClass(Class: IClassCode): Promise<IClassCode> {
        return this.$apiService.sendAuth("IItemClassService/AddClass", Class);
    }
}
